import AddCurrencyConfigDialog from "./addCurrencyConfigDialog.container";

export default AddCurrencyConfigDialog